import { FC } from 'react'

import { useI18n } from '../../../hooks'

import './index.css'

const FacultyEmail: FC = () => {
  const { t } = useI18n()
  return (
    <div className="faculty-email">
      <div className="faculty-email-title-ctn">
        <i className="faculty-email-title-icon feather-tag"></i>
        <h1 className="faculty-email-title heavy">{t('Faculty_yourStudentsSaveToo')}</h1>
      </div>
      <p className="faculty-email-description">{t('Faculty_shareDealsText')}</p>
      <a
        className="faculty-email-button light"
        href="mailto:?subject=Academic software savings for students&body=For students needing software for their classes this semester, I encourage you to visit https://onthehub.com. OnTheHub offers savings of up to 90 percent on leading software from Microsoft, Adobe, IBM, SPSS, and more."
      >
        {t('Faculty_shareDealsNow')}
      </a>
    </div>
  )
}

export default FacultyEmail
